import { TabPanel, TabView } from "primereact/tabview";
import { FC } from "react";
import IconNotificationDocument from "../../images/icon_notification_document.svg";
import IconNotificationDocumentSelected from "../../images/icon_notification_document_selected.svg";

import IconNotificationPayment from "../../images/akar_icons_money.svg";
import IconNotificationPaymentSelected from "../../images/akar_icons_money_selected.svg";
import IconNotificationTurn from "../../images/ic_bi_truck.svg";
import IconNotificationTurnSelected from "../../images/ic_bi_truck_selected.svg";
import { ContainerCommon } from "../AdminDocumentValidation/CommonButtonNotification";
import Sidebar from "../Sidebar/Sidebar";

import IcNotificationIcon from "../../images/ic_notification_icon_new.svg";
import { NotificationSideDiv } from "../AdminDocumentValidation/AdminDocumentValidationStyles";
import { BellNotificationComponent } from "./BellNotificationComponent";
import { ContentDocumentNotifications } from "./ContentDocumentNotifications";
import {
  DivNotificationTabs,
  TitleNotification,
} from "./SidebarNotificationsStyles";
import { Subject } from "rxjs";

interface ISidebarNotifications {
  onOutsideClick: any;
  countState: any;
  loadCountNotification$: Subject<void>;
}

export const SidebarNotifications: FC<ISidebarNotifications> = (props) => {
  const { onOutsideClick, countState, loadCountNotification$ } = props;

  const tabHeaderITemplate = (imgCbk, t) => (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
        style={{
          fontSize: "1.2rem",
          fontWeight: 600,
          fontFamily: "Montserrat",
        }}
      >
        {imgCbk(options.selected)}
        {options.titleElement}
        <div
          style={{
            background: `${options.selected ? "#FF6F61" : "#002E6C"}`,
            color: "#FFFFFF",
            padding: "0.4rem",
            borderRadius: "1rem",
            fontSize: "1rem",
            marginLeft: "0.4rem",
          }}
        >
          {t}
        </div>
      </button>
    );
  };

  return (
    <Sidebar onOutsideClick={onOutsideClick}>
      <ContainerCommon width="44rem">
        <NotificationSideDiv>
          <div>
            <img
              src={IcNotificationIcon}
              alt="Processing request"
              className="img-notification"
            />
          </div>
          <TitleNotification>NOTIFICACIONES</TitleNotification>
        </NotificationSideDiv>
        <DivNotificationTabs>
          <TabView
            style={{ backgroundColor: "yellow" }}
            className="notification-tab-class-div"
          >
            {countState.modules.map((module, i) => {
              const imgTypeSelected =
                module.category === "document_validation"
                  ? IconNotificationDocumentSelected
                  : module.category === "payment_validation"
                  ? IconNotificationPaymentSelected
                  : IconNotificationTurnSelected;
              const imgTypeDefault =
                module.category === "document_validation"
                  ? IconNotificationDocument
                  : module.category === "payment_validation"
                  ? IconNotificationPayment
                  : IconNotificationTurn;
              return (
                <TabPanel
                  key={i}
                  header={module.label}
                  headerTemplate={tabHeaderITemplate((t) => {
                    return (
                      <img
                        src={t ? imgTypeSelected : imgTypeDefault}
                        alt=""
                        className="image-icon"
                      />
                    );
                  }, module.count)}
                >
                  {module.count > 0 && (
                    <ContentDocumentNotifications
                      endpoints={module.endpoints}
                      onOutsideClick={onOutsideClick}
                      loadCountNotification$={loadCountNotification$}
                    />
                  )}
                  {module.count === 0 && (
                    <BellNotificationComponent
                      typeNotification={module.label.toLowerCase()}
                    />
                  )}
                </TabPanel>
              );
            })}
          </TabView>
        </DivNotificationTabs>
      </ContainerCommon>
    </Sidebar>
  );
};
